module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjMwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDMwIDUwIj4NCgk8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSI1LDUgMjUsMjUgNSw0NSAiLz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/arrowRight.svg
// module id = ./node_modules/graphcool-styles/icons/stroke/arrowRight.svg
// module chunks = 0 1